/**
 * Promo Banner Timer — countdown logic.
 * Works for multiple instances on the same page.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initTimer(timerEl) {
    const endStr = timerEl.dataset.countdown;
    if (!endStr) return;

    const endTime = new Date(endStr).getTime();
    if (isNaN(endTime)) return;

    const daysEl = timerEl.querySelector('[data-days]');
    const hoursEl = timerEl.querySelector('[data-hours]');
    const minsEl = timerEl.querySelector('[data-minutes]');
    const secsEl = timerEl.querySelector('[data-seconds]');

    function tick() {
      const diff = endTime - Date.now();

      if (diff <= 0) {
        daysEl && (daysEl.textContent = '00');
        hoursEl && (hoursEl.textContent = '00');
        minsEl && (minsEl.textContent = '00');
        secsEl && (secsEl.textContent = '00');
        return;
      }

      const totalSecs = Math.floor(diff / 1000);
      const days  = Math.floor(totalSecs / 86400);
      const hours = Math.floor((totalSecs % 86400) / 3600);
      const mins  = Math.floor((totalSecs % 3600) / 60);
      const secs  = totalSecs % 60;

      daysEl  && (daysEl.textContent  = pad(days));
      hoursEl && (hoursEl.textContent = pad(hours));
      minsEl  && (minsEl.textContent  = pad(mins));
      secsEl  && (secsEl.textContent  = pad(secs));
    }

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('.promo-banner__timer[data-countdown]').forEach(initTimer);
})();
